// src/main/constants/funding-collection.ts
import { Currency } from "@types";

/**
 * Currencies where the post-login "funding profile collection point" must collect a real
 * funding profile (e-wallet preferred, else bank), not just a legal name. COP/PEN PGWs
 * require real funding data.
 */
export const FUNDING_PROFILE_COLLECTION_CURRENCIES: Currency[] = [Currency.COP, Currency.PEN];

/**
 * LEGACY fallback only — consumed solely by getPersonalInfoRequirement when BE's
 * memberSettings.playerInfoCollectionMode is absent (pre-BE-deploy or stale cached settings).
 * Once every environment serves the config, delete this constant and the legacy branch.
 */
export const PERSONAL_INFO_COLLECTION_CURRENCIES: Currency[] = [Currency.PEN];

// Colombia CC: 6-10 digits, no leading zero.
export const CC_NUMBER_REGEX = /^[1-9]\d{5,9}$/;
